'use strict';

const slider = require('../components/slider');

var CART_PAGE_SELECTOR = '.cart-page';
var updateMiniCart = true;

function updateCartPage() {
    $.ajax({
        url: window.location.href, // Cart-Show page
        method: 'GET',
        success: function (response) {
            var $html = $('<div>').html(response);

            // Replace only cart container (important!)
            var $newCart = $html.find(CART_PAGE_SELECTOR);
            $(CART_PAGE_SELECTOR).replaceWith($newCart);

            // Apply slider after loadig the images
            setTimeout (function () {
                slider();
                $.spinner().stop();
            }, 500);
        }
    });
}

module.exports = function () {
    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $(CART_PAGE_SELECTOR).length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;

        if ($(CART_PAGE_SELECTOR).length) {
            updateCartPage();
        }
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });
};
